<template>
  <v-container>
    <v-form v-loading="tload" style="max-width:600px;margin:auto">
      <v-text-field v-model="formData.appid" label="小程序APPID"></v-text-field>
      <v-text-field v-model="formData.secret" label="小程序APP SECRET" class="mt-3"></v-text-field>
      <v-text-field v-model="formData.mp_appid" label="公众号APPID" class="mt-3"></v-text-field>
      <v-text-field v-model="formData.mp_secret" label="公众号APP SECRET" class="mt-3"></v-text-field>
      <v-text-field v-model="formData.mp_templateId" label="新订单通知" class="mt-3"></v-text-field>
      <v-btn class="mt-3 dark" :loading="tload" @click="submit()">保存</v-btn>
    </v-form>
  </v-container>
</template>

<script>
let _this;
export default {
  props: {
    load: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        appid: "",
        secret: "",
        mp_appid: "",
        mp_secret: "",
        mp_templateId:""
      },
      pageLoad: this.load,
      tload: false
    };
  },
  watch: {
    load(val) {
      if (val) {
        this.pageLoad = val;
      }
    },
    pageLoad(val) {
      if (val) {
        this.getConfig();
      }
    }
  },

  mounted() {
    _this = this;
    _this.getConfig();
  },
  methods: {
    //获取配置
   async  getConfig() {
      _this.tload = true;
    const res = await this.$post(
        "admin/getConfig",
      )
      _this.tload = false;
      if (res.errno == 0) {
        if (res.data) {
          _this.formData = (res.data);
        }
      }
    },
   async  submit() {
      this.tload = true;
   const res = await  this.$post(
        "admin/updateConfig",
        this.formData,
      );
      _this.tload = false;
      if (res.errno === 0) {
            _this.$message({
              showClose: true,
              message: res.data,
              type: "success"
            });
          }
          await this.getConfig()
    }
  }
}
</script>
